export default function filter (){
	let linkCategory = $('.categoryBlog__link');
	var first = true;

	function faqquestions(page){
		$('.modalLoader').show();
		let form = '#blog .form';
		let category = $('.categoryBlog__link.active').length > 0 ? $('.categoryBlog__link.active').data('category') : '';
		$.ajax({
			type        : $(form).attr('method'),
			url         : $(form).attr('action'),
			data        : ($(form).serialize() + '&_token=' + $('meta[name="csrf-token"]').attr('content') + '&category='+category+(page ? ('&page='+page) : '')),
			dataType    : "json",
			success:function(data) {
				$('.modalLoader').hide();
				let content = '';
				$.each(data.contents, function(key, el){
					content += `<a href="${el.link}">
								<div class="blog__iten">
									<div class="blog__image" style="background-image: url('${el.image}')">
										<span class="blog__btnMore" style="background-color: ${el.color};">leia mais</span>
									</div>
									<div class="blog__text">
								<div class="blog__tags">`;
					$.each(el.tags, function(index, val) {
						content += `<p class="blog__tagsIten" style="background-color: ${val.color};">${val.title}</p>`;
					});
					content += 	`</div>
								<h2 class="blog__title">${el.title}</h2>
								<p class="blog__est">Tempo de leitura: ${el.est}</p>
								<div class="blog__description">${el.description}</div>
								<p class="blog__date" style="color: ${el.color};">${jsi18n.publish_by} <span class="blog__bold">${el.author}</span>, ${jsi18n.day} ${el.date}</p>
							</div>
						</div>
						</a>`;
				})
				$('.blog__contentItens').html(content).show();
				$('.pagination-container').html(data.pagination);
				$('.pagination-container .pager').addClass('pager--blue');
				if(!first){
					$('html, body').animate({scrollTop: $('.blog__head').offset().top}, 300);
				} else{
					first = false;
				}
			}
		});
	}

	$(function() {
		$(".newsletter-areas, .blogNewsletter__input, .check_news").on('change', function() {
			if ($(this).closest('form').find('.newsletter-areas').val() && $(this).closest('form').find('.blogNewsletter__input').is(':valid') && $(this).closest('form').find('.check_news').is(':checked')) {
				$(this).closest('form').find(".bag__btnNext").attr({
					disabled: false
				});
			} else {
				$(this).closest('form').find(".bag__btnNext").attr({
					disabled: true
				});
			}
		});
	});

	if($('#blog .blog-form').length > 0){
		faqquestions();
	}

	$('#blog .blog-form').submit(function(e){
		e.preventDefault();
		faqquestions();
	})

	$('#blog .blog-form .form__select').change(function(e){
		e.preventDefault();
		faqquestions();
	})

	if($('#blog .blog-form').length > 0){
		linkCategory.click(function(e){
			/*e.preventDefault();
			linkCategory.removeClass('active');
			$(this).addClass('active');
			faqquestions();*/
		});
	}

	$('body').on('click', '#blog .pager .pager__link', function(event) {
		event.preventDefault();
		if(!$(this).hasClass('.pager__link--active')){
			faqquestions($(this).attr('data-page'));
		}
	});
}